import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  Typography,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import Toolbar from "./Toolbar";
import {
  apiEndpoints,
  apiGetRequest,
  apiDeleteRequest,
  apiPostRequest,
} from "src/utils/api/api";
import { addCreatedAndUpdatedFields } from "src/utils/utils";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink as RouterLink } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import KmPageTitle from "src/components/layout/KmPageTitle";
import SendIcon from "@material-ui/icons/Send";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const RowButtons = (row, customHandlers) => {
  return (
    <Box>
      <Tooltip title="Podgląd">
        <IconButton
          aria-label="Podgląd"
          component={RouterLink}
          to={`/powiadomienia/podgladpowiadomienia/${row.id}`}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
      {row.status === "draft" ? (
        <Tooltip title="Edytuj">
          <IconButton
            aria-label="Edytuj"
            component={RouterLink}
            to={`/powiadomienia/edycjapowiadomienia/${row.id}`}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <></>
      )}
      {/* <Tooltip title="Wyślij ręcznie">
        <IconButton
          aria-label="Wyślij ręcznie"
          onClick={() => customHandlers.sendHandler(row)}
        >
          <SendIcon />
        </IconButton>
      </Tooltip> */}
    </Box>
  );
};

const Mailings = ({
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    enableGlobalLoader();
    apiGetRequest(apiEndpoints.getMailings.path, true)
      .then((data) => {
        disableGlobalLoader();
        setRows(
          addCreatedAndUpdatedFields(
            data,
            "createdBy",
            "createdAt",
            "updatedBy",
            "updatedAt",
            ", "
          )
        );
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const sendHandler = (row) => {
    enableGlobalLoader();
    apiPostRequest(
      apiEndpoints.sendMailing.path,
      {
        id: row.id,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
      })
      .catch((error) => {
        disableGlobalLoader();

        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 5000,
          message: "Wystapił błąd",
        });
      });
  };

  const headCells = [
    {
      id: "subject",
      numeric: false,
      disablePadding: true,
      fieldName: "subject",
      sortable: true,
      main: true,
      label: "Temat",
      width: "40%",
    },
    {
      id: "messagetypename",
      fieldName: "messageTypeName",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Rodzaj wiadomości",
    },
    {
      id: "status",
      fieldName: "status",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      dataType: 2,
      dataLabels: {
        draft: "Wersja robocza",
        pending: "Oczekiwanie na wysyłkę",
        sending: "Wysyłanie",
        sent: "Wysłane",
        partially_sent: "Częściowo wysłane",
        error: "Błąd",
      },
      label: "Status",
    },
    {
      id: "created",
      fieldName: "createdAt",
      fieldName2: "createdBy",
      kmUdField: true,
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Kiedy i kto utworzył",
    },
    {
      id: "sentstartat",
      fieldName: "sendStartedAt",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Data rozpoczęcia wysyłki",
    },
    {
      id: "sentEndAt",
      fieldName: "sendFinishedAt",
      numeric: false,
      disablePadding: false,
      sortable: true,
      searchable: true,
      label: "Data zakończenia wysyłki",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: { sendHandler },
      component: RowButtons,
    },
  ];

  const onSelectedRowIdsChanged = (viewSelectedRowIds) => {
    setSelectedRowIds(viewSelectedRowIds);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    enableGlobalLoader();
    setOpen(false);
    apiDeleteRequest(apiEndpoints.deleteMailings.path, selectedRowIds, true)
      .then((data) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 3000,
          message: "Wybrane powiadomienia zostały usunięte",
        });
        setReloadCounter(reloadCounter + 1);
      })
      .catch((error) => {
        disableGlobalLoader();
        navigate("/powiadomienia");
      });
  };

  return (
    <Page className={classes.root} title="Powiadomienia">
      <KmPageTitle>Powiadomienia</KmPageTitle>
      <Container maxWidth={false}>
        <Toolbar dialogHandler={handleClickOpen} />
        <Box mt={3}>
          <KmFilteredTable
            headCells={headCells}
            rows={rows}
            onSelectedRowIdsChange={onSelectedRowIdsChanged}
          />
          <Dialog
            fullScreen={fullScreen}
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Usuwanie powiadomień"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Czy na na pewno chcesz usunąć zaznaczone elementy?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Nie
              </Button>
              <Button onClick={handleDelete} color="primary" autoFocus>
                Tak
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(Mailings);
